import React, { Fragment } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dialog, DialogContent, DialogContentText, DialogTitle, Drawer, IconButton, withStyles, Grid, Hidden } from '@material-ui/core'
import { Room, Close } from '@material-ui/icons'
import ImageSlider from './ImageSlider'
import SimilarProperties from './SimilarProperties'
import RequestForm from './RequestForm'
import Loader from './Loader'
import Button from './ButtonMaterial'
import * as utils from '../utils'
import Favorite from 'features/favorites/components/Favorite'
import flagIcon from 'images/flag-icon.svg'
import MapPropertyDetail from './map/MapPropertyDetailModal'

import {
  fetchProperty,
  showFlashMessage,
  showFlashMessageOnUnexpectedError,
  fetchZillow,
  addPropertyToFavorites,
  removePropertyFromFavorites,
} from '../actions'
import isempty from 'lodash.isempty'
import { FacebookShareButton, FacebookIcon, EmailIcon, EmailShareButton, TwitterIcon, TwitterShareButton } from 'react-share'
import emailWhiteIcon from '../images/emailIconWhite.png'
import phoneIcon from '../images/telephone.png'
import ReasonForm from './ReasonForm'
import { CONTRACT, SOLD, ASSINGMENTS_LOCATION_LABEL } from '../constants'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  dialogPaper: {
    margin: '10px auto',
    width: '96%',
    maxWidth: '1024px',
    borderRadius: '0',
    [theme.breakpoints.down('sm')]: {
      margin: '15px auto !important',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto !important',
      width: '100%',
      paddingBottom: '0px',
    },
  },
  Dialog: {
    maxWidth: '1024px',
    width: '100%',
    margin: '15px auto',
    [theme.breakpoints.down('sm')]: {
      margin: '15px 0',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '0',
    },
    '& paperScrollBody': {
      marginLeft: '15px',
      marginRight: '15px',
      minWidth: '1024px',
    },
  },
  dialogHead: {
    minHeight: '65px',
    backgroundColor: '#1c1e27',
    boxShadow: '0 2px 9px 0 rgba(0, 0, 0, 0.19)',
    display: 'flex',
    alignItems: 'center',
    padding: '24px 24px 20px',
    [theme.breakpoints.down('xs')]: {
      padding: '24px 15px 20px',
    },
    '& > h2': {
      color: '#ffffff',
      fontSize: '20px',
      fontWeight: '400',
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
      },
    },
  },
  requestProperty: {
    minHeight: '424px',
    flexDirection: 'column',
    '& .MuiGrid-container-15': {
      justifyContent: 'space-between !important',
    },
  },
  priceAndTags: {
    position: 'relative',
    '& > h2': {
      fontSize: '40px',
      fontWeight: '500',
      color: '#ffffff',
      margin: '0',
      maxWidth: '95%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.down('xs')]: {
        fontSize: '28px',
        margin: '0 0 17px',
      },
    },
  },
  propOverview: {
    backgroundColor: '#333645',
    padding: '24px',
    [theme.breakpoints.down('xs')]: {
      padding: '23px 15px',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    '& > div > p': {
      fontSize: '17px',
      fontWeight: '400',
      lineHeight: '1.42',
      color: '#ffffff',
      margin: '10px 0 14px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        margin: '17px 0 10px',
      },
    },
  },
  propSpecifications: {
    color: '#00bcb5',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '85%',
    [theme.breakpoints.down('961')]: {
      maxWidth: '100%',
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: '25%',
      textAlign: 'center',
      marginRight: '8px',
      '& > h4': {
        fontSize: '30px',
        fontWeight: '500',
        letterSpacing: '1.4px',
        margin: 0,
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('750')]: {
          fontSize: '22px',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '18px',
          marginBottom: '5px',
        },
      },
      '& > h5': {
        fontSize: '18px',
        letterSpacing: '0.8px',
        margin: 0,
        fontWeight: '400',
        [theme.breakpoints.down('750')]: {
          fontSize: '15px',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '13px',
          letterSpacing: '0',
        },
      },
    },
  },
  propListSection: {
    marginTop: '16px',
    color: '#ffffff',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '85%',
    [theme.breakpoints.down('961')]: {
      maxWidth: '100%',
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: '35%',
      textAlign: 'center',
      marginRight: '8px',
      '& > h4': {
        fontSize: '20px',
        fontWeight: '500',
        letterSpacing: '1.4px',
        margin: 0,
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('750')]: {
          fontSize: '22px',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '18px',
          marginBottom: '5px',
        },
      },
      '& > h5': {
        fontSize: '13px',
        letterSpacing: '0.8px',
        margin: 0,
        fontWeight: '400',
        [theme.breakpoints.down('750')]: {
          fontSize: '15px',
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '13px',
          letterSpacing: '0',
        },
      },
    },
  },
  listingsection: {
    padding: '0px 32px 0px',
    [theme.breakpoints.down('xs')]: {
      padding: '0px 15px',
    },
    '& > div': {
      padding: '35px 0 0 0',
    },
  },
  listingBox: {
    padding: '0',
    [theme.breakpoints.down('xs')]: {
      padding: '20px 15px 6px',
    },
    '& > h5': {
      fontSize: '15px',
      color: '#333645',
      letterSpacing: '1px',
      fontWeight: '400',
      margin: '0 0 6px',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& > span': {
        color: '#bdbdbd',
        fontWeight: '400',
        textTransform: 'lowercase',
      },
    },
    '& > h3': {
      fontSize: '25px',
      fontWeight: '500',
      color: '#333645',
      margin: '0',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& > p': {
      fontSize: '14px',
      color: '#00bcb5',
      margin: '0',
      '& > span': {
        maxWidth: '80%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
  card: {
    borderRadius: '4px',
    boxShadow: '0 3px 11px 0 rgba(78, 78, 78, 0.17)',
    display: 'flex',
    maxWidth: '290px',
    minWidth: '290px',
    minHeight: '92px',
    maxHeight: '92px',
  },
  cardimg: {
    minWidth: '92px',
    maxWidth: '92px',
  },
  cardContent: {
    padding: '10px',
    width: 'calc(100% - 92px)',
    '& > h2': {
      fontSize: '18px',
      fontWeight: '500',
      color: '#231f20',
      margin: '0 0 6px',
      maxWidth: '175px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& > h4': {
      fontSize: '14px',
      fontWeight: '500',
      color: '#00bcb5',
      margin: '0 0 6px',
      textTransform: 'uppercase',
      maxWidth: '175px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& > p': {
      fontSize: '14px',
      fontWeight: '400',
      color: '#838383',
      margin: '0',
      maxWidth: '175px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  cross: {
    width: 'auto',
    height: 'auto',
    [theme.breakpoints.down('xs')]: {
      height: '25px',
      marginTop: '-2px',
    },
    padding: '0px',
  },
  cardDescription: {
    minHeight: '100px',
    [theme.breakpoints.down('xs')]: {
      minHeight: 'unset',
    },
  },
  buyBtn: {
    width: '158px',
    [theme.breakpoints.down('xs')]: {
      width: '130px',
    },
  },
  pills: {
    fontSize: '12px',
    fontWeight: '400',
    textTransform: 'uppercase',
    lineHeight: '1.67',
    letterSpacing: '0.5px',
    color: 'rgba(265, 265, 265, 0.64)',
    borderRadius: '18px',
    backgroundColor: 'rgba(255, 255, 255, 0.07)',
    padding: '4px 10px',
    marginRight: '7px',
    display: 'inline-block',
  },
  titleWrapper: { display: 'flex' },
  locationIcon: {
    color: '#fdd200',
    marginLeft: '-5px',
    marginRight: '8px',
    width: '23px',
  },
  propertyAddress: {
    lineHeight: '1.3',
    paddingRight: '10px',
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'center',
    },
  },
  propertyDetailContent: {
    padding: '0',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  shareActions: {
    width: '40%',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      width: '60%',
    },
  },
  shareButton: {
    cursor: 'pointer',
  },
  requestInfoButton: {
    [theme.breakpoints.down('sm')]: {
      bottom: '0',
      left: '0',
      margin: '0 0 10px 15px',
      width: 'calc(100% - 92px)',
    },
  },
  requestFullButton: {
    [theme.breakpoints.down('sm')]: {
      bottom: '0',
      left: '0',
      margin: '0 15px 10px',
      width: 'calc(100% - 30px)',
    },
  },
  gridSettings: {
    backgroundColor: '#333645',
  },
  contactSellerButton: {
    width: '60%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  propertyField: {
    display: 'flex',
    margin: '12px 0',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  propertyLabel: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#00bcb5',
    lineHeight: '1.56',
    paddingRight: '10px',
    minWidth: '100px',
    alignSelf: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      minWidth: '30%',
    },
  },
  propertyValue: {
    fontSize: '17px',
    fontWeight: '400',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      width: '100%',
    },
    textDecoration: 'none',
  },
  emailbtnIcon: {
    marginRight: '5px',
  },
  phonebtnIcon: {
    marginRight: '5px',
  },
  contactText: {
    marginRight: '5px',
    fontSize: '17px',
    lineHeight: '25px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      flexDirection: 'column',
    },
  },
  contactContainer: {
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  },
  replaceProertyBar: {
    width: '100%',
    backgroundColor: '#333645',
    padding: '15px 0',
    display: 'flex',
    justifyContent: 'center',
    '& a': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.43',
      color: '#ef4135',
      cursor: 'pointer',
      '& span': {
        margin: '0 5px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '52px',
      height: '52px',
      backgroundColor: 'transparent',
      padding: '0',
      position: 'absolute',
      right: '15px',
      bottom: '10px',
      '& a': {
        width: '100%',
        borderRadius: '4px',
        background: '#f1f1f1',
        '& img': {
          width: '18px',
        },
        '& span': {
          display: 'none',
        },
      },
    },
  },

  propertyTag: {
    display: 'inline-block',
    margin: '0',
    padding: '3px 6px',
    fontSize: '12px',
    fontWeight: '500',
    color: '#fff',
    borderRadius: '2px',
    position: 'absolute',
    right: '0',
    top: '12px',
    [theme.breakpoints.down('767')]: {
      top: '6px',
    },
  },
  newTag: {
    backgroundColor: '#d24c4c',
  },
  soldTag: {
    backgroundColor: '#2fae54',
  },
  underTag: {
    backgroundColor: '#e4ad5e',
  },
})

class DetailsModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      property: null,
      showCloseButton: false,
      contactSellerDisplayed: false,
      flagProperty: false,
      anchorEl: null,
    }
  }

  componentDidMount() {
    if (this.props.propertyId) this.fetchProperty(this.props.propertyId)
    document.addEventListener('keydown', this.sliderKeyNavigation)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.sliderKeyNavigation)
  }

  sliderKeyNavigation = event => {
    switch (event.keyCode) {
      case 27:
        // do not close on escape if image modal is open
        document.getElementsByClassName('ReactModalPortal').length === 0 && this.props.onClose()
        break
      default:
        break
    }
  }

  fetchProperty = async propertyId => {
    const { onClose, showFlashMessage, showFlashMessageOnUnexpectedError, user } = this.props
    try {
      const response = await this.props.fetchProperty(propertyId, user)
      if (isempty(response.errors)) {
        utils.trackEvent({ category: 'Property Detail', action: 'Detail view selected for property Id - ' + propertyId })
        this.setState({
          property: response.property,
        })
        response.property.showZestimate &&
          (response.property.type === null || response.property.type.toLowerCase() !== process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE) &&
          this.fetchZillowProperty(response.property)
      } else {
        onClose()
        showFlashMessage(true, response.errors[0])
      }
    } catch (error) {
      onClose()
      showFlashMessageOnUnexpectedError(error, `Something went wrong, we aren't able to find that property`)
    }
  }

  fetchZillowProperty = async property => {
    try {
      const response = await this.props.fetchZillow(property)
      if (isempty(response.errors)) {
        this.setState({
          property: response.property,
        })
      } else {
        showFlashMessage(true, response.errors[0])
      }
    } catch (error) {
      showFlashMessageOnUnexpectedError(error)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.propertyId !== this.props.propertyId && this.props.propertyId) {
      this.fetchProperty(this.props.propertyId)
      this.setState({ contactSellerDisplayed: false })
    }
  }

  showMobileRequestForm = () => {
    this.setState({ showCloseButton: true })
  }

  handleFormClose = () => {
    this.setState({ showCloseButton: false })
  }

  buildFranchiseeData = franchisee => {
    const { classes } = this.props
    const franchiseeDescription = `${franchisee.name}`
    const buildFranchiseeValue = franchisee => (
      <a
        className={classes.propertyValue}
        href={`${window.location.protocol}//${franchisee.subdomain}.${process.env.REACT_APP_BASE_DOMAINS}${
          window.location.port ? ':' + window.location.port : ''
        }`}>
        {franchiseeDescription}
      </a>
    )

    return utils.isUserLogged(this.props.user) && franchisee.subdomain && franchisee.isActive ? (
      <div className={classes.propertyField}>
        <div className={classes.propertyLabel}>More Properties by</div>
        <div className={classes.propertyValue}>{buildFranchiseeValue(franchisee)}</div>
      </div>
    ) : null
  }

  buildContactSeller = franchisee => {
    const { classes } = this.props
    if (this.state.contactSellerDisplayed) {
      return (
        <div className={classes.propertyField}>
          <div className={classes.propertyLabel}>Contact</div>
          <div className={classes.propertyValue}>
            {franchisee.phone ? (
              <div className={classes.contactContainer}>
                <span className={classes.phonebtnIcon}>{franchisee.phone ? <img height="15px" src={phoneIcon} alt={'phone'} /> : ''}</span>{' '}
                <span className={classes.contactText}>{franchisee.phone}</span>
              </div>
            ) : null}
            <div className={classes.contactContainer}>
              {' '}
              <span className={classes.emailbtnIcon}>{franchisee.email ? <img height="15px" src={emailWhiteIcon} alt={'email'} /> : ''}</span>
              <span className={classes.contactText}>{franchisee.email}</span>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <Button
          className={classes.contactSellerButton}
          onClick={() => {
            utils.trackEvent({ category: 'Contact seller', action: 'Contact info requested for property id ' + this.state.property.id })
            this.setState({ contactSellerDisplayed: true })
          }}>
          Contact Seller
        </Button>
      )
    }
  }

  toggleReasonForm = event => {
    !this.state.flagProperty &&
      this.setState({
        anchorEl: event.currentTarget,
      })
    const { flagProperty } = this.state
    this.setState({
      flagProperty: !flagProperty,
    })
    !this.state.flagProperty &&
      this.setState({
        anchorEl: null,
      })
  }

  render() {
    const {
      classes,
      open = false,
      noMap = false,
      searchString,
      user,
      addPropertyToFavorites,
      removePropertyFromFavorites,
      showFlashMessage,
      onClose,
    } = this.props

    const { property, flagProperty, anchorEl } = this.state

    const propertySharingUrl =
      property &&
      `${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${window.location.port ? ':' + window.location.port : ''}/listings/${property.id}`
    const isAssignment = property && property.type && property.type.toLowerCase() === process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE
    const propertySharingMessage =
      property && property.address && !(property.type && property.type.toLowerCase() === process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE)
        ? ['address', 'city', 'state', 'zip']
            .map(val => property[val])
            .filter(val => !!val)
            .join(', ')
        : `${ASSINGMENTS_LOCATION_LABEL}`

    const lat = (property && property.lat) || process.env.REACT_APP_DEFAULT_LAT
    const lng = (property && property.lon) || process.env.REACT_APP_DEFAULT_LNG
    const center = { lat: parseFloat(lat), lng: parseFloat(lng) }

    return (
      <div>
        <Dialog
          id="property_detail"
          classes={{ paper: classes.dialogPaper }}
          open={open}
          onClose={() => onClose()}
          scroll={'body'}
          aria-labelledby="scroll-dialog-title"
          disableEscapeKeyDown>
          {property ? (
            <Fragment>
              <DialogTitle id="scroll-dialog-title" className={classes.dialogHead}>
                <div className={classes.titleWrapper}>
                  <span>
                    <Room className={classes.locationIcon} />
                  </span>
                  <span className={classes.propertyAddress}>
                    {property.address && !(property.type && property.type.toLowerCase() === process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE)
                      ? ['address', 'city', 'state', 'zip']
                          .map(val => property[val])
                          .filter(val => !!val)
                          .join(', ')
                      : `${ASSINGMENTS_LOCATION_LABEL}`}
                  </span>
                </div>
                <IconButton className={classes.cross} color="inherit" onClick={() => onClose()} aria-label="Close">
                  <Close />
                </IconButton>
              </DialogTitle>

              <DialogContent className={classes.propertyDetailContent}>
                {/* Property overview and form below */}
                <div className={classes.requestProperty}>
                  <Grid container wrap="nowrap">
                    {/* left / propOverview section below */}
                    <Grid item md={8} xs={12}>
                      <div className={classes.propOverview}>
                        <div className={classes.priceAndTags}>
                          {property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD ? (
                            <span className={`${classes.propertyTag} ${classes.soldTag}`}>Sold</span>
                          ) : property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === CONTRACT ? (
                            <span className={`${classes.propertyTag} ${classes.underTag}`}>Under Contract</span>
                          ) : property.startListingOn && utils.isNewlyListedProperty(property.startListingOn) ? (
                            <span className={`${classes.propertyTag} ${classes.newTag}`}>New</span>
                          ) : (
                            ''
                          )}
                          <h2 className={property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD ? 'strike-through' : ''}>
                            {property.price > 0 && `$${utils.withCommas(property.price)}`}
                          </h2>
                          <p>
                            {property.type && <span className={classes.pills}>{property.type}</span>}
                            {property.homeType && <span className={classes.pills}>{property.homeType}</span>}
                          </p>
                        </div>
                        <div className={classes.propSpecifications}>
                          {property.beds > 0 && (
                            <div>
                              <h4>{property.beds}</h4>
                              <h5>
                                Bed
                                {property.beds > 1 ? 's' : ''}
                              </h5>
                            </div>
                          )}
                          {property.baths > 0 && (
                            <div>
                              <h4>{property.baths}</h4>
                              <h5>
                                Bath
                                {property.baths > 1 ? 's' : ''}
                              </h5>
                            </div>
                          )}
                          {property.sqft > 0 && (
                            <div>
                              <h4>{utils.withCommas(property.sqft)}</h4>
                              <h5>SqFt</h5>
                            </div>
                          )}
                          {property.year > 0 && (
                            <div>
                              <h4>{property.year}</h4>
                              <h5>Year Built</h5>
                            </div>
                          )}
                        </div>
                        {/* Listing price / listingsection below */}
                        {((property.showZestimate && property.zestimate) || property.arv || !!property.repairEstimate) && (
                          <div className={classes.propListSection}>
                            {property.arv > 0 && (
                              <div>
                                <h4>{`$${utils.withCommas(property.arv)}`}</h4>
                                <h5>Estimated ARV</h5>
                              </div>
                            )}
                            {property.repairEstimate > 0 && (
                              <div>
                                <h4>{`$${utils.withCommas(property.repairEstimate)}`}</h4>
                                <h5>Repair Info</h5>
                              </div>
                            )}
                            {property.showZestimate && property.zestimate > 0 && (
                              <div>
                                <h4>{`$${utils.withCommas(property.zestimate)}`}</h4>
                                <h5>
                                  Zestimate <span>(from zillow)</span>
                                </h5>
                              </div>
                            )}
                          </div>
                        )}
                        {/* Listing price / listingsection above */}
                        <div className={classes.cardDescription}>
                          <p>{property.description || ''}</p>
                          {property.amenities && (
                            <div className={classes.propertyField}>
                              <div className={classes.propertyLabel}>Amenities</div>
                              <div className={classes.propertyValue}>{property.amenities}</div>
                            </div>
                          )}
                        </div>
                        {utils.isUserLogged(this.props.user) && property.franchisee && (property.franchisee.phone || property.franchisee.email) && (
                          <div>{this.buildContactSeller(property.franchisee)}</div>
                        )}
                        <div className={classes.actions}>
                          <div className={classes.shareActions}>
                            <Favorite
                              addPropertyToFavorites={addPropertyToFavorites}
                              removePropertyFromFavorites={removePropertyFromFavorites}
                              propertyId={property.id}
                              showFlashMessage={showFlashMessage}
                              user={user}
                            />
                            <FacebookShareButton className={classes.shareButton} url={propertySharingUrl} quote={propertySharingMessage}>
                              <FacebookIcon size={40} iconBgStyle={{ fill: 'transparent' }} round />
                            </FacebookShareButton>
                            <TwitterShareButton className={classes.shareButton} url={propertySharingUrl} title={propertySharingMessage}>
                              <TwitterIcon size={40} iconBgStyle={{ fill: 'transparent' }} round />
                            </TwitterShareButton>
                            <EmailShareButton className={classes.shareButton} url={propertySharingUrl} subject={propertySharingMessage}>
                              <EmailIcon size={40} iconBgStyle={{ fill: 'transparent' }} round />
                            </EmailShareButton>
                          </div>
                        </div>
                        {property.franchisee && <div>{this.buildFranchiseeData(property.franchisee)}</div>}
                      </div>
                    </Grid>
                    {/* left / propOverview section above */}
                    <Hidden smDown>
                      <Grid item md={4} className={classes.gridSettings}>
                        {user.isLoadingUserInfo ? <Loader /> : <RequestForm propertyID={Number(property.id)} user={user} />}
                      </Grid>
                    </Hidden>
                  </Grid>
                  <ImageSlider images={property.images} key={Date.now()} />
                  {/* Map view */}
                  {!isAssignment && <MapPropertyDetail center={center} />}
                  {/* Map view */}
                  {/* Similar properties / similarProps below */}
                  <SimilarProperties propertyId={property.id} property={property} noMap={noMap} searchStringForSimilarProp={searchString} />
                  {/* Similar properties / similarProps above */}
                  <Hidden mdUp>
                    <Drawer anchor="bottom" open={this.state.showCloseButton} onClose={this.handleFormClose}>
                      {
                        <RequestForm
                          propertyID={Number(property.id)}
                          user={user}
                          handleClose={this.handleFormClose}
                          showCloseButton={this.state.showCloseButton}
                        />
                      }
                    </Drawer>
                  </Hidden>
                </div>
                <DialogContentText />
                <Hidden mdUp>
                  <Button
                    className={utils.isUserLogged(this.props.user) ? classes.requestInfoButton : classes.requestFullButton}
                    onClick={this.showMobileRequestForm}>
                    Request Info
                  </Button>
                </Hidden>
              </DialogContent>
              {utils.isUserLogged(this.props.user) && (
                <div className={classes.replaceProertyBar}>
                  <a onClick={this.toggleReasonForm}>
                    <img alt="flag" src={flagIcon} /> <span>Flag this property</span>
                  </a>
                </div>
              )}
            </Fragment>
          ) : (
            // 100vh is for viewport height
            // 20px is margin from top & bottom
            <Loader
              style={{
                height: 'calc(100vh - 20px)',
                backgroundColor: '#333645',
              }}
            />
          )}
          {property && utils.isUserLogged(this.props.user) && (
            <Grid item>
              <Grid container>
                <ReasonForm
                  listing={this.props.listing}
                  handleClose={() => this.props.onClose()}
                  propertyId={property.id}
                  anchorEl={anchorEl}
                  open={flagProperty}
                  onClose={() => this.toggleReasonForm()}
                  propertyRemoved={() => this.props.propertyRemoved(property.id)}
                />
              </Grid>
            </Grid>
          )}
        </Dialog>
      </div>
    )
  }
}

DetailsModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  user: PropTypes.object.isRequired,
  addPropertyToFavorites: PropTypes.func.isRequired,
  removePropertyFromFavorites: PropTypes.func.isRequired,
  showFlashMessage: PropTypes.func.isRequired,
  showFlashMessageOnUnexpectedError: PropTypes.func.isRequired,
  fetchProperty: PropTypes.func.isRequired,
  listing: PropTypes.bool,
  propertyRemoved: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { fetchProperty, addPropertyToFavorites, removePropertyFromFavorites, showFlashMessage, showFlashMessageOnUnexpectedError, fetchZillow },
    dispatch
  )
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DetailsModal)
)



// WEBPACK FOOTER //
// ./src/components/DetailsModal.js